import { CmsApi } from 'src/app/hickory-api';

export class MockCmsApi extends CmsApi { }
